const ADITIONAL_OPTIONS = {
  COMMENT_FOR_TRANSPORTIST: 'COMMENT_FOR_TRANSPORTIST',
  INTERNAL_REFERENCE: 'INTERNAL_REFERENCE',
  INSURANCE: 'INSURANCE',
  APPOINTMENT_INSTRUCTIONS: 'APPOINTMENT_INSTRUCTIONS',
};

const INSURANCE_MAX_QUANTITY = 300000;

export default {
  ADITIONAL_OPTIONS,
  INSURANCE_MAX_QUANTITY,
};
